import { defer } from 'lodash'
import fetch from '../../../Services/fetch'

export default () => (dispatch) => {

  defer(() => dispatch(fetch()))

}
